export const allNotes = [
    'c0', 'c0s', 'd0', 'd0s', 'e0', 'f0', 'f0s', 'g0', 'g0s', 'a0', 'a0s', 'b0', 'c1', 'c1s', 'd1', 'd1s', 'e1', 'f1', 'f1s', 'g1', 'g1s', 'a1', 'a1s', 'b1', 'c2', 'c2s', 'd2', 'd2s', 'e2', 'f2', 'f2s', 'g2', 'g2s', 'a2', 'a2s', 'b2', 'c3'
];
export const allKeys = [
    'z', 'x', 'c', 'v', 'b', 'n', 'm', 'a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', 'q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '-'
];
export const keyToNote = {
    z: 'c0',
    x: 'c0s',
    c: 'd0',
    v: 'd0s',
    b: 'e0',
    n: 'f0',
    m: 'f0s',
    a: 'g0',
    s: 'g0s',
    d: 'a0',
    f: 'a0s',
    g: 'b0',
    h: 'c1',
    j: 'c1s',
    k: 'd1',
    l: 'd1s',
    q: 'e1',
    w: 'f1',
    e: 'f1s',
    r: 'g1',
    t: 'g1s',
    y: 'a1',
    u: 'a1s',
    i: 'b1',
    o: 'c2',
    p: 'c2s',
    1: 'd2',
    2: 'd2s',
    3: 'e2',
    4: 'f2',
    5: 'f2s',
    6: 'g2',
    7: 'g2s',
    8: 'a2',
    9: 'a2s',
    0: 'b2',
    '-': 'c3'
};
export const noteToKey = {
    c0: 'z',
    c0s: 'x',
    d0: 'c',
    d0s: 'v',
    e0: 'b',
    f0: 'n',
    f0s: 'm',
    g0: 'a',
    g0s: 's',
    a0: 'd',
    a0s: 'f',
    b0: 'g',
    c1: 'h',
    c1s: 'j',
    d1: 'k',
    d1s: 'l',
    e1: 'q',
    f1: 'w',
    f1s: 'e',
    g1: 'r',
    g1s: 't',
    a1: 'y',
    a1s: 'u',
    b1: 'i',
    c2: 'o',
    c2s: 'p',
    d2: '1',
    d2s: '2',
    e2: '3',
    f2: '4',
    f2s: '5',
    g2: '6',
    g2s: '7',
    a2: '8',
    a2s: '9',
    b2: '0',
    c3: '-'
};